import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/residents/resident-death";

export const Route = createFileRoute("/admin/_residents/resident-death")({
  component: Page,
});
